import { FilterArea } from "#src/components/FilterArea";
import {
  DropdownInput,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import type { InvestigationSearchStatusType } from "@validereinc/domain";
import { Investigations } from "@validereinc/domain-controllers";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationHistoryFilterAreas.module.scss";

const cx = classNames.bind(styles);
const { InvestigationSearchStatusOptions } = Investigations.view;

export const INVESTIGATION_HISTORY_FILTER_KEYS = {
  title: "title",
  status: "status",
} as const;

export type InvestigationHistoryFiltersType = {
  [INVESTIGATION_HISTORY_FILTER_KEYS.title]?: string;
  /** `""` is written by `FilterArea` when every option is cleared. */
  [INVESTIGATION_HISTORY_FILTER_KEYS.status]?:
    | InvestigationSearchStatusType[]
    | "";
};

export const InvestigationHistoryFilterArea = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => (
  <FilterArea.Root
    storageKey={filterConfigStorageKey}
    defaultValues={{}}
  >
    <FilterArea.Container aria-label="Filters for Investigations history">
      <FilterArea.Content>
        {({ handleOnChange }) => (
          <div className={cx("filters")}>
            <TextInput
              name={INVESTIGATION_HISTORY_FILTER_KEYS.title}
              className={cx("filters__search")}
              type="search"
              placeholder="Search investigations..."
              isLabelShown={false}
              isInline
              isFluid
              onChange={(value) =>
                handleOnChange(value, INVESTIGATION_HISTORY_FILTER_KEYS.title)
              }
            />
            <DropdownInput
              name={INVESTIGATION_HISTORY_FILTER_KEYS.status}
              label="Status"
              placeholder="Select a Status"
              options={InvestigationSearchStatusOptions}
              labelKey="label"
              valueKey="value"
              isInline
              isMulti
              isSearchable={false}
              isFluid
              isLabelShown={false}
              isOptionalTextShown={false}
              onChange={(value) =>
                handleOnChange(value, INVESTIGATION_HISTORY_FILTER_KEYS.status)
              }
            />
          </div>
        )}
      </FilterArea.Content>
    </FilterArea.Container>
  </FilterArea.Root>
);
